/*
 *  Document   : verify-mobile.js
 *  Author     : Exapoint
 *
 */

// Import required modules

import ExaHelpers from "../exa_helpers";

export default class VerifyMobile {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["VerifyMobile"] = this;
        this.init();
    }

    init() {
        ExaHelpers.validation();
        this.initValidation();
    }

    initValidation() {
        $('.js-validation').validate({
            ignore: [],
            rules: {
                'code': {
                    digits:true,
                    required: true,
                    minlength: 4,
                    maxlength: 4,
                },
            },
        });
    }
}
